import './App.scss';// eslint-disable-next-line
// import { useEffect } from 'react';
import Home from './pages/Home';
import Details from './pages/details/Details';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Footer from './components/footer/Footer';
import Catalog from './pages/Catalog';
import FoodCatalog from './pages/FoodCatalog';

function App() {
  return (
    <BrowserRouter>
      <div>
        <Routes>
          <Route exact path='/' element={<Home />} />
          <Route exact path='/categories' element={<Catalog />} />
          <Route exact path='/areas' element={<Catalog />} />
          <Route exact path='/alphabets' element={<Catalog />} />
          <Route exact path='/alphabets/:alphabet' element={<FoodCatalog />} />
          <Route exact path='/categories/:category' element={<FoodCatalog />} />
          <Route exact path='/areas/:area' element={<FoodCatalog />} />
          <Route exact path='/alphabets/:alphabet/:id' element={<Details />} />
          <Route exact path='/categories/:category/:id' element={<Details />} />
          <Route exact path='/areas/:area/:id' element={<Details />} />
          <Route exact path='/foods/:id' element={<Details />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
